"use client";
import s from "./CustomFieldSubtitle.module.scss";

export interface CustomFieldSubtitleProps {
  label?: string;
}

export default function CustomFieldSubtitle(props: CustomFieldSubtitleProps) {
  const { label } = props;

  return <span className={s.subtitle}>{label}</span>;
}
